import { render } from "./ClientUseManual.vue?vue&type=template&id=821f68ec&scoped=true&ts=true"
import script from "./clientUseManualHelper.ts?vue&type=script&lang=ts"
export * from "./clientUseManualHelper.ts?vue&type=script&lang=ts"

import "./ClientUseManual.vue?vue&type=style&index=0&id=821f68ec&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-821f68ec"]])

export default __exports__